export default __webpack_public_path__ + "static/media/flat-lay-health-still-life-arrangement-with-copy-space.87f69144.jpg";